import React, { ChangeEvent, useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  FormControl,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  ListItemText,
  Chip,
  Radio,
  RadioGroup,
  Autocomplete as AutocompleteMUI,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useParams } from "react-router-dom";
import { Autocomplete } from "@react-google-maps/api";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  UploadMedia,
  UploadMediaWithoutCompress,
  Uploadpdf,
  UploadVideo,
} from "../../utils/uploadMedia";
import {
  useAddClassMutation,
  useGetTutorListQuery,
  useLazyGetClassByIdQuery,
  useUpdateClassMutation,
  useLazyGetSubjectListQuery,
} from "../../services/class";
import { errorToast, getFromStorage, successToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { Add, Delete, Edit, Save } from "@mui/icons-material";
import { EmbedPDF } from "@simplepdf/react-embed-pdf";
import timezone from "../../utils/time";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { isNumber, isValidInput } from "../../utils/validation";

import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import {
  CLASS_PAYMENT,
  CLASS_TYPE,
  CLASS_TYPE2,
  ClassMode,
  LISTING,
  RECURRENCE_TYPE,
  TeachingLanguage,
} from "../../helpers/constants/enums";
import { useLazyGetCatSubListQuery } from "../../services/category";
import ClassCalendar from "../../features/classes/Calendar";
import CustomSelector from "../../features/classes/CustomSelector";
import EditText from "../../components/EditText";
import moment from "moment";

export const classOptions = [
  { label: "Pre-K (Ages 3-4)", value: "1" },
  { label: "Kindergarten (Ages 5-6)", value: "2" },
  { label: "Grade 1 (Ages 6-7)", value: "3" },
  { label: "Grade 2 (Ages 7-8)", value: "4" },
  { label: "Grade 3 (Ages 8-9)", value: "5" },
  { label: "Grade 4 (Ages 9-10)", value: "6" },
  { label: "Grade 5 (Ages 10-11)", value: "7" },
  { label: "Grade 6 (Ages 11-12)", value: "8" },
  { label: "Grade 7 (Ages 12-13)", value: "9" },
  { label: "Grade 8 (Ages 13-14)", value: "10" },
  { label: "Grade 9 (Ages 14-15)", value: "11" },
  { label: "Grade 10 (Ages 15-16)", value: "12" },
  { label: "Grade 11 (Ages 16-17)", value: "13" },
  { label: "Grade 12 (Ages 17-18)", value: "14" },
  { label: "College (Ages 18+)", value: "15" },
  { label: "Adult Learning (Ages 25+)", value: "16" },
  { label: "All Ages", value: "17" },
];

const ProfileSetup = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [profilePicture, setProfilePicture] = useState("");
  const [video, setVideo] = useState("");
  const [classDetails, setClassDetails] = useState<any>();

  // State for dropdown selections
  const [selectedTutor, setSelectedTutor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedGrade, setSelectedGrade] = useState<string[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedClassType, setSelectedClassType] = useState("");
  const [selectedAvailability, setSelectedAvailability] = useState(false);
  const [selectedFreeLesson, setSelectedFreeLesson] = useState(false);
  const [selectedCoTeacher, setSelectedCoTeacher] = useState("");
  const [allSubject, setAllSubject] = useState<any>();
  const [allPromoCode, setAllPromoCode] = useState<any[]>([]);
  const [selectedPromoCodes, setSelectedPromoCodes] = useState<string[]>([]);
  const [allClass, setAllClass] = useState<any>();
  const [updateClass] = useUpdateClassMutation();
  const [selectedSetting, setSelectedSetting] = useState<any>("");
  const [slotTime, setSlotTime] = useState<{ start: string; end: string }[]>(
    []
  );
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [slotDuration, setSlotDuration] = useState<number>(30); // Default to 30 minutes

  const addOneHour = (time: string): string => {
    const [hours, minutes] = time.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes + 60, 0, 0);
    return date.toTimeString().slice(0, 5);
  };

  const doesOverlap = (start: string, end: string): boolean => {
    const toMinutes = (t: string) => {
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };

    const newStart = toMinutes(start);
    const newEnd = toMinutes(end);

    return slotTime.some(({ start: existingStart, end: existingEnd }) => {
      const existStart = toMinutes(existingStart);
      const existEnd = toMinutes(existingEnd);

      return newStart < existEnd && newEnd > existStart;
    });
  };

  const [selectedTimezone, setSelectedTimezone] = useState<any>("");
  const [material, setMaterial] = useState<any>();
  const [error, setError] = useState<any>();
  const [tempDate, setTempDate] = useState<Dayjs | null>(null);
  const [selectedDates, setSelectedDates] = useState<string[]>([]);
  const [dates, setDates] = useState<any>();

  const handleAddDate = () => {
    if (tempDate) {
      const formatted = tempDate.format("YYYY-MM-DD");
      if (!selectedDates.includes(formatted)) {
        setSelectedDates((prev) => [...prev, formatted]);
      }
      setTempDate(null);
    }
  };

  // const handleRemoveDate = (index: number) => {
  //   setSelectedDates((prev) => prev.filter((_, i) => i !== index));
  // };

  // Remove date handler
  const handleRemoveDate = (index: number) => {
    const newDates = [...dates];
    newDates.splice(index, 1);
    setDates(newDates);
  };

  const formatDateSlots = (
    selectedDates: string[],
    slotTime: { start: string; end: string }[]
  ) => {
    const result: { date: string; startTime: string; endTime: string }[] = [];

    selectedDates.forEach((dateStr) => {
      const date = dayjs(dateStr).startOf("day");
      slotTime.forEach((slot) => {
        const [startHour, startMin] = slot.start.split(":").map(Number);
        const [endHour, endMin] = slot.end.split(":").map(Number);

        const startTime = date.hour(startHour).minute(startMin);
        const endTime = date.hour(endHour).minute(endMin);

        result.push({
          // date: date.startOf("date").toISOString(),
          date: dayjs(date).add(1, "day").toISOString(),
          startTime: startTime.toISOString(),
          endTime: endTime.toISOString(),
        });
      });
    });

    return result;
  };
  // API calls
  const { data: tutorData } = useGetTutorListQuery();
  const [subjectApi] = useLazyGetCatSubListQuery();
  const [promoCode] = useLazyGetCatSubListQuery();
  const [getClassById] = useLazyGetClassByIdQuery();

  const fetchSubject = async () => {
    if (!selectedTutor) return;

    try {
      const response = await subjectApi({
        type: LISTING.TUTOR_SUBJECT,
        tutorId: formik.values.tutor,
      }).unwrap();

      if (response.statusCode === 200) {
        setAllSubject(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPromoCodes = async () => {
    if (!selectedTutor) return;

    try {
      const response = await promoCode({
        type: LISTING.PROMOCODE,
        tutorId: formik.values.tutor,
      }).unwrap();

      if (response.statusCode === 200) {
        setAllPromoCode(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [addClass] = useAddClassMutation();
  const [autocomplete, setAutocomplete] = useState<any>();
  const [tags, setTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState("");
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editValue, setEditValue] = useState("");
  const [date, setDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [slotDates, setSlotDates] = useState<string[]>([]);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [repeatEveryWeeks, setRepeatEveryWeeks] = useState(1);
  const [continueForWeeks, setContinueForWeeks] = useState(0);
  const [selectionMode, setSelectionMode] = useState<"date" | "range">("date");
  const [rangeType, setRangeType] = useState<"daily" | "weekly" | "monthly">(
    "daily"
  );
  // const [rangeType, setRangeType] = useState<"daily" | "weekly" | "monthly">(
  //   "daily"
  // );
  // const [startDate, setStartDate] = useState<string | null>(null);
  // const [endDate, setEndDate] = useState<string | null>(null);
  const addTag = () => {
    const trimmed = tagInput.trim();
    if (trimmed && !tags.includes(trimmed)) {
      setTags([...tags, trimmed]);
      setTagInput("");
    }
  };

  // useEffect(() => {
  //   const dummyAPIResponse = {
  //     slotDates: [
  //       "2025-07-05T00:00:00.000Z",
  //       "2025-07-07T00:00:00.000Z",
  //       "2025-07-08T00:00:00.000Z",
  //     ],
  //     selectionMode: "range" as const,
  //     rangeType: "weekly" as const,
  //     startDate: "2025-07-05T00:00:00.000Z",
  //     endDate: "2025-07-20T00:00:00.000Z",
  //   };

  //   setSelectionMode(dummyAPIResponse.selectionMode);
  //   setRangeType(dummyAPIResponse.rangeType);
  //   setStartDate(dummyAPIResponse.startDate);
  //   setEndDate(dummyAPIResponse.endDate);
  //   setSlotDates(dummyAPIResponse.slotDates);
  // }, []);

  const updateTag = (index: number) => {
    const trimmed = editValue.trim();
    if (trimmed && tags[index] !== trimmed && !tags.includes(trimmed)) {
      const updated = [...tags];
      updated[index] = trimmed;
      setTags(updated);
    }
    setEditingIndex(null);
    setEditValue("");
  };

  const removeTag = (index: number) => {
    setTags((prev) => prev.filter((_, i) => i !== index));
  };

  // Form validation schema
  const validationSchema = Yup.object().shape({
    // Required fields
    image: Yup.string().required("Class Thumbnail is required"),
    video: Yup.string().required("Tease video is required"),
    name: Yup.string()
      .required("Topic is required")
      .max(100, "Topic must be at most 100 characters"),
    tutor: Yup.string().required("Tutor is required"),
    subject: Yup.string().required("Subject is required"),
    grade: Yup.array()
      .min(1, "At least one grade must be selected")
      .required("Grade is required"),

    description: Yup.string()
      .required("Description is required")
      .min(20, "Description must be at least 20 characters")
      .max(1000, "Description must be at most 1000 characters"),
    // learninig: Yup.string()
    //   .required("Learning objectives are required")
    //   .min(20, "Learning objectives must be at least 20 characters")
    //   .max(500, "Learning objectives must be at most 500 characters"),
    // learninigOutcome1: Yup.string()
    //   .required("All learners outcome is required")
    //   .max(500, "Must be at most 500 characters"),
    // learninigOutcome2: Yup.string()
    //   .required("Most learners outcome is required")
    //   .max(500, "Must be at most 500 characters"),
    // learninigOutcome3: Yup.string()
    //   .required("Some learners outcome is required")
    //   .max(500, "Must be at most 500 characters"),
    language: Yup.string().required("Language is required"),
    classType: Yup.string().required("Class mode is required"),
    timezone: Yup.string().required("Timezone is required"),
    // fee: Yup.number()
    //   .required("Fee is required")
    //   .min(1, "Fee must be at least 1")
    //   .max(10000, "Fee must be at most 10,000"),

    // Conditional validation for seat
    seat: Yup.number().required("Seat limit is required"),

    // Conditional validations for address/location
    address: Yup.string().when("classType", (classType: any, schema: any) => {
      return classType === "1" || classType === "3"
        ? schema.required("Address is required for offline/hybrid classes")
        : schema;
    }),

    // Optional fields
    // video: Yup.string(),
    material: Yup.string(),
    customNote: Yup.string().max(
      1000,
      "Custom note must be at most 1000 characters"
    ),
    coTeahcer: Yup.string(),
    promocode: Yup.array(),

    // Array validations
    searchTags: Yup.array()
      .of(Yup.string().max(20, "Tag must be at most 20 characters"))
      .max(10, "Maximum 10 tags allowed"),
  });
  // Time slot validation
  const validateTimeSlots = () => {
    if (slotTime.length === 0) {
      errorToast("Please add at least one time slot");
      return false;
    }
    return true;
  };

  // Date validation
  const validateDates = () => {
    if (!dates || dates.length === 0) {
      errorToast("Please select at least one date");
      return false;
    }
    return true;
  };

  // Tag validation
  const validateTags = () => {
    if (tags.length > 10) {
      errorToast("Maximum 10 tags allowed");
      return false;
    }

    const invalidTag = tags.find((tag) => tag.length > 20);
    if (invalidTag) {
      errorToast(`Tag "${invalidTag}" is too long (max 20 chars)`);
      return false;
    }

    return true;
  };

  // Formik initialization
  const formik = useFormik({
    initialValues: {
      image: "",
      video: "",
      subject: "",
      setting: "",
      description: "",
      learninig: "",
      grade: [],
      promocode: [],
      fee: "",
      seat: "",
      language: "",
      tutor: "",
      customNote: "",
      availability: false,
      isFree: false,
      tages: "",
      paymentType: CLASS_PAYMENT.SESSION,
      material: "",
      coTeahcer: "",
      classType: "",
      classType2: "",
      longitude: "",
      latitude: "",
      coTeacherEmail: "",
      learninigOutcome1: "",
      learninigOutcome2: "",
      learninigOutcome3: "",
      name: "",
      address: "",
      timezone: "",
      objective: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setFormSubmitted(true);

      // Mark these fields as touched to trigger validation
      formik.setFieldTouched("image", true);
      formik.setFieldTouched("video", true);

      // Validate time slots
      if (slotTime.length === 0) {
        // errorToast("Please add at least one time slot");
        return;
      }
      // if (formik.values.image.length === 0 || formik.values.image === "") {
      //   errorToast("Class Thumbnail is required");
      //   return;
      // }
      // if (formik.values.video.length === 0 || formik.values.image === "") {
      //   errorToast("Teaser video is required");
      //   return;
      // }
      if (
        (selectedClassType === "1" || selectedClassType === "3") &&
        formik.values.address.length === 0
      ) {
        errorToast("Address is required");
        return;
      }

      // Validate slot dates
      if (slotDates.length === 0) {
        errorToast("Please select at least one date");
        return;
      }

      // Validate slot duration
      if (!slotDuration || slotDuration <= 0) {
        errorToast("Please select a valid slot duration");
        return;
      }

      // Validate weekly schedule settings
      if (selectionMode === "range" && !endDate) {
        errorToast("Please select an end date for recurring classes");
        return;
      }

      // Additional validations
      // if (!validateTimeSlots()) return;
      // if (!validateDates()) return;
      // if (!validateTags()) return;

      // Validate time slots and dates
      // if (slotTime.length === 0) {
      //   errorToast("Please add at least one time slot");
      //   return;
      // }

      // if (selectedDates.length === 0) {
      //   errorToast("Please select at least one date");
      //   return;
      // }

      //      const body = {
      //   selectedDates,
      //   selectedSlots,
      //   typeOfClass: classType2,
      // };

      const body = {
        // tutorId: values.tutor,
        ...(_id ? {} : { tutorId: values.tutor }),
        subjectId: values.subject,
        topic: values.name,
        description: values.description,
        ...(values.learninig ? { objective: values.learninig } : {}),
        duration: slotDuration,
        ...(values.learninigOutcome3
          ? { someOutcome: values.learninigOutcome3 }
          : {}),
        ...(values.learninigOutcome1
          ? { allOutcome: values.learninigOutcome1 }
          : {}),
        ...(values.learninigOutcome2
          ? { mostOutcome: values.learninigOutcome2 }
          : {}),
        thumbnail: values.image,
        teaser: values.video,
        ...(values.isFree ? { fees: values.fee } : {}),
        isFreeLesson: !values.isFree,
        grades: values.grade,
        promoCodeId: selectedPromoCodes,
        seats: Number(values.seat),
        coTutorId: values.coTeahcer,
        material: [values.material],
        searchTags: tags,
        language: values.language,
        ...(values.customNote ? { notes: values.customNote } : {}),
        classMode: values.classType,
        timezone: values.timezone,
        canBePrivate: values.availability,
        ...(selectedClassType === "1" || selectedClassType === "3"
          ? {
              longitude: values.longitude,
              latitude: values.latitude,
              address: values.address,
            }
          : {}),
        startDate: startDate,
        ...(endDate
          ? { endDate: moment(endDate).startOf("day").utc().toISOString() }
          : {}),
        // classType: values.classType2,
        // recurrenceType: RECURRENCE_TYPE.WEEKLY,
        repeatEvery: repeatEveryWeeks,
        ...(continueForWeeks ? { continueFor: continueForWeeks } : {}),
        // setting: 1,
        ...(values.paymentType ? { payment: values.paymentType } : {}),
        typeOfClass: values.classType2,
        classSlots: formatDateSlots(slotDates, slotTime),
      };

      console.log(body, "bodybodybody");
      // const body2 = {
      //   subjectId: values.subject,
      //   topic: values.name,
      //   description: values.description,
      //   objective: values.learninig,
      //   someOutcome: values.learninigOutcome3,
      //   allOutcome: values.learninigOutcome1,
      //   mostOutcome: values.learninigOutcome2,
      //   thumbnail: values.image,
      //   teaser: values.image,
      //   fees: values.fee,
      //   classId: values.grade,
      //   promoCodeId: selectedPromoCodes,
      //   seats: Number(values.seat),
      //   coTutorId: values.coTeahcer,
      //   material: [values.material],
      //   searchTags: tags,
      //   language: values.language,
      //   notes: values.customNote,
      //   classMode: values.classType,
      //   timezone: values.timezone,
      //   canBePrivate: values.availability,
      //   ...(selectedClassType == "1" || selectedClassType == "3"
      //     ? {
      //         longitude: values.longitude,
      //         latitude: values.latitude,
      //         address: values.address,
      //       }
      //     : {}),
      //   classType:
      //     selectionMode === "range" ? CLASS_TYPE.RECURRENCE : CLASS_TYPE.NORMAL,
      //   ...(selectionMode === "range"
      //     ? {
      //         recurrenceType:
      //           rangeType === "daily"
      //             ? RECURRENCE_TYPE.DAILY
      //             : rangeType === "weekly"
      //               ? RECURRENCE_TYPE.WEEKLY
      //               : RECURRENCE_TYPE.MONTHLY,
      //         startDate: startDate,
      //         endDate: endDate,
      //       }
      //     : {}),
      //   // setting: values.setting,
      //   classSlots: formatDateSlots(slotDates, slotTime),
      // };

      // return;
      setIsLoading(true);
      if (_id) {
        try {
          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response: any = await updateClass({
            body: encryptedBody,
            id: _id,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Class updated successfully");
            navigate("/manage-classes");
          }
        } catch (error: any) {
          console.error("Error adding class:", error);
          errorToast(error?.data?.message || "");
        } finally {
          setIsLoading(false);
        }
      } else {
        try {
          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response: any = await addClass({
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Class added successfully");
            navigate("/manage-classes");
          }
        } catch (error: any) {
          console.error("Error adding class:", error);
          errorToast(error?.data?.message || "");
        } finally {
          setIsLoading(false);
        }
      }
    },
  });
  // Handlers for dropdown changes
  const handleTimezoneChange = (event: any) => {
    setSelectedTimezone(event.target.value);
    formik.setFieldValue("timezone", event.target.value);
    formik.setFieldTouched("timezone", true);
  };

  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
    formik.setFieldValue("tutor", event.target.value);
    formik.setFieldTouched("tutor", true);
    formik.setFieldValue("subject", "");
    formik.setFieldValue("grade", "");
    formik.setFieldValue("promocode", "");
    formik.setFieldValue("language", "");
    formik.setFieldValue("coTeahcer", "");
    setSelectedSubject("");
    setSelectedGrade([]);
    setSelectedLanguage("");
    setSelectedCoTeacher("");
  };

  const handleSetting = (event: any) => {
    setSelectedSetting(event.target.value);
    formik.setFieldValue("setting", event.target.value);
    formik.setFieldTouched("setting", true);
  };

  const handleSubjectChange = (event: any) => {
    setSelectedSubject(event.target.value);
    formik.setFieldValue("subject", event.target.value);
    formik.setFieldTouched("subject", true);
  };

  const handleGradeChange = (event: any) => {
    const value = event.target.value;
    setSelectedGrade(typeof value === "string" ? value.split(",") : value);
    formik.setFieldValue(
      "grade",
      typeof value === "string" ? value.split(",") : value
    );
    formik.setFieldTouched("grade", true);
  };

  const handleLanguageChange = (event: any) => {
    setSelectedLanguage(event.target.value);
    formik.setFieldValue("language", event.target.value);
    formik.setFieldTouched("language", true);
  };

  const handleClassTypeChange = (event: any) => {
    setSelectedClassType(event.target.value);
    formik.setFieldValue("classType", event.target.value);
    formik.setFieldTouched("classType", true);
  };

  const handleAvailabilityChange = (event: any) => {
    setSelectedAvailability((prev) => !prev);
    formik.setFieldValue("isFree", !formik.values.availability);
  };
  const handleFreeLessonChange = (event: any) => {
    setSelectedFreeLesson((prev) => !prev);
    formik.setFieldValue("availability", !formik.values.availability);
  };

  const handleCoTeacherChange = (event: any) => {
    setSelectedCoTeacher(event.target.value);
    formik.setFieldValue("coTeahcer", event.target.value);
  };

  // Media upload handlers
  const handleImageUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) return;
    setIsLoading(true);
    try {
      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        setProfilePicture(res?.data?.image);
        formik.setFieldValue("image", res?.data?.image);
        formik.setFieldTouched("image", false);
      } else {
        errorToast(res?.message || "Error uploading image");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image");
    } finally {
      setIsLoading(false);
    }
  };

  const handleVideoUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setIsLoading(true);
    try {
      const res = await UploadMediaWithoutCompress(file);
      if (res?.statusCode === 200) {
        setVideo(res?.data?.image);
        formik.setFieldValue("video", res?.data?.image);
        formik.setFieldTouched("video", false);
      } else {
        errorToast(res?.message || "Error uploading video");
      }
    } catch (error) {
      console.error("Error uploading video:", error);
      errorToast("Error uploading video");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMaterialUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;
    setIsLoading(true);
    try {
      if (!file) {
        if (type === "material") {
          setMaterial(null);
        }
        return;
      }

      let res;
      if (file.type === "application/pdf") {
        res = await Uploadpdf(file);
        if (res?.statusCode === 200) {
          setMaterial(res?.data?.image);
          formik.setFieldValue("material", res?.data?.image);
        } else {
          errorToast(res?.message);
        }
      } else {
        res = await UploadMedia(file);
        if (res?.statusCode === 200) {
          setMaterial(res?.data?.image);
          formik.setFieldValue("material", res?.data?.image);
        } else {
          errorToast(res?.message);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      errorToast("Error uploading file. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };

  const handleClear = () => {
    formik.setFieldValue("latitude", 0);
    formik.setFieldValue("longitude", 0);
    formik.setFieldValue("address", "");
  };

  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place && place.address_components) {
        let address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          let types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || "");
        formik.setFieldValue("longitude", lng || "");
      }
    }
  };

  useEffect(() => {
    if (formik.values.tutor) {
      fetchSubject();
      getPromoCodes();
    }
  }, [formik.values.tutor, selectedTutor]);

  // useEffect(() => {
  //   if (_id) {
  //     getClass(_id);
  //   }
  // }, [_id]);

  useEffect(() => {
    if (_id) {
      const fetchClassData = async () => {
        setIsLoading(true);
        try {
          const response = await getClassById({ classId: _id }).unwrap();
          if (response.statusCode === 200) {
            const classData = response.data;

            // Set formik values
            formik.setValues({
              image: classData.thumbnail,
              video: classData.teaser,
              subject: classData.subjects?._id || "",
              setting: classData.setting || "",
              description: classData.description,
              learninig: classData.objective,
              grade: classData?.grades?.map(String) || [],
              promocode: classData?.promoCodeId || [],
              fee: classData.fees.toString(),
              seat: classData.seats.toString(),
              language: classData.language.toString(),
              tutor: classData.tutor?._id || "",
              customNote: classData.notes || "",
              availability: classData.canBePrivate,
              paymentType: classData?.payment,
              tages: "",
              coTeacherEmail: classData.coTeacherEmail || "",
              isFree: classData?.isFreeLesson,
              latitude: classData?.latitude,
              longitude: classData?.longitude,
              material: classData.material?.[0] || "",
              coTeahcer: classData.coTutor?._id || "",
              classType2: classData.typeOfClass || "",
              classType: classData.classMode.toString(),
              learninigOutcome1: classData.allOutcome,
              learninigOutcome2: classData.mostOutcome,
              learninigOutcome3: classData.someOutcome,
              name: classData.topic,
              address: classData?.address,
              timezone: classData?.classslots[0]?.timezone,
              objective: classData.objective,
            });
            setSelectedFreeLesson(!classData?.isFree);

            if (classData?.promoCodes?.length > 0) {
              setSelectedPromoCodes(
                classData?.promoCodes?.map((item: any) => item?._id)
              );
            }
            // Set other state values
            setSlotDuration(classData?.duration);
            setContinueForWeeks(classData?.continueFor);
            if (classData?.endDate) setEndDate(classData?.endDate);
            setRepeatEveryWeeks(classData?.repeatEvery);
            setSelectedTutor(classData.tutor?._id || "");
            setSelectedSubject(classData.subjects?._id || "");
            setSelectedGrade(classData?.grades?.map(String) || []);
            setSelectedLanguage(classData.language.toString());
            setSelectedClassType(classData.classMode.toString());
            setSelectedAvailability(classData.canBePrivate);
            setSelectedCoTeacher(classData.coTutor?._id || "");
            setSelectedSetting(classData.setting || "");
            setSelectedTimezone(classData?.classslots[0]?.timezone);
            setSelectionMode(
              classData?.classType === CLASS_TYPE.RECURRENCE ? "range" : "date"
            );
            if (classData?.classType === CLASS_TYPE.RECURRENCE) {
              setRangeType(
                classData?.recurrenceType === RECURRENCE_TYPE.DAILY
                  ? "daily"
                  : classData?.recurrenceType === RECURRENCE_TYPE.WEEKLY
                    ? "weekly"
                    : "monthly"
              );
              setStartDate(classData?.startDate);
              setEndDate(classData?.endDate);
            }
            setMaterial(classData.material?.[0] || null);
            setProfilePicture(classData.thumbnail);
            setVideo(classData.teaser);

            // Set tags
            if (classData.searchTags) {
              setTags(classData.searchTags);
            }

            // Set class slots
            if (classData.classslots && classData.classslots.length > 0) {
              const uniqueDates = Array.from(
                new Set(
                  classData.classslots.map(
                    (slot: any) => slot.date.split("T")[0]
                  )
                )
              );

              setDates(uniqueDates.map((date: any) => dayjs(date)));
              setSlotDates(uniqueDates as string[]);

              const timeSlots = classData.classslots.map((slot: any) => ({
                start: dayjs(slot.startTime).format("HH:mm"),
                end: dayjs(slot.endTime).format("HH:mm"),
              }));

              // Remove duplicate time slots
              const uniqueTimeSlots = Array.from(
                new Set(timeSlots.map((slot: any) => JSON.stringify(slot)))
              ).map((slot: any) => JSON.parse(slot));

              setSlotTime(uniqueTimeSlots);
            }
          }
        } catch (error) {
          console.error("Error fetching class data:", error);
          errorToast("Failed to load class data");
          navigate("/manage-classes");
        } finally {
          setIsLoading(false);
        }
      };

      fetchClassData();
    }
  }, [_id]);

  console.log(formik.values, "formik.values");

  return (
    <MainContainer>
      <div className="main_loyout">
        <Card className="cards">
          <div className="dashboard">
            <h1 className="mn_hdng">{_id ? "Edit Class" : "Add Class"}</h1>
            <Loader isLoad={isLoading} />
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-classes")}
            >
              Back
            </Button>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                {/* Thumbnail Image Upload */}
                <Grid item xs={12}>
                  <Typography className="custom_label">
                    Class Thumbnail
                  </Typography>
                  {formik.values.image ? (
                    <div className="upload_image_preview">
                      {/* <CardMedia
                        component="img"
                        image={formik.values.image}
                        alt="thumbnail"
                        sx={{ width: 350, height: 150, borderRadius: 0 }}
                      /> */}
                      <img
                        style={{ width: 350, height: 150, borderRadius: 0 }}
                        src={formik.values.image}
                        alt="thumbnail"
                      />
                      <CancelIcon
                        onClick={() => {
                          setProfilePicture("");
                          formik.setFieldValue("image", "");
                        }}
                      />
                    </div>
                  ) : (
                    <Box className="upload_image">
                      <label htmlFor="icon-button-file">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{ accept: "image/png,image/jpeg" }}
                          onChange={handleImageUpload}
                        />
                        <Button component="span" className="upload_image_btn">
                          <img
                            style={{ width: 350, height: 150, borderRadius: 0 }}
                            src="/static/images/document.png"
                            alt=""
                          />
                          <CameraAltIcon />
                        </Button>
                      </label>
                    </Box>
                  )}
                  {/* Add validation error display */}
                  {formik.touched.image && formik.errors.image && (
                    <Typography color="error" variant="caption">
                      {formik.errors.image}
                    </Typography>
                  )}
                </Grid>
                {/* Teaser Video Upload */}
                <Grid item xs={12}>
                  <Typography className="custom_label">Teaser Video</Typography>
                  {formik.values.video ? (
                    <div className="upload_image_preview">
                      <video
                        style={{ width: 350, height: 150, borderRadius: 0 }}
                        src={formik.values.video}
                        controls
                        autoPlay
                        muted
                      />
                      <CancelIcon
                        sx={{
                          zIndex: 1000,
                        }}
                        onClick={() => {
                          setVideo("");
                          formik.setFieldValue("video", "");
                        }}
                      />
                    </div>
                  ) : (
                    <Box className="upload_image">
                      <label htmlFor="icon-button-file-video">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file-video"
                          type="file"
                          inputProps={{ accept: "video/mp4" }}
                          onChange={handleVideoUpload}
                        />
                        <Button component="span" className="upload_image_btn">
                          <img
                            style={{ width: 350, height: 150, borderRadius: 0 }}
                            src="/static/images/document.png"
                            alt=""
                          />
                          <CameraAltIcon />
                        </Button>
                      </label>
                    </Box>
                  )}
                  {formik.touched.video && formik.errors.video && (
                    <Typography color="error" variant="caption">
                      {formik.errors.video}
                    </Typography>
                  )}
                </Grid>
                {/* Material */}
                <Grid item xs={12}>
                  <Typography className="custom_label">
                    Upload Material
                  </Typography>

                  {material ? (
                    material.endsWith(".pdf") ? (
                      <EmbedPDF companyIdentifier="yourcompany">
                        <a href={`${material}`}>
                          <div className="upload_image_preview2">
                            <CardMedia
                              component="img"
                              image="/static/images/pencil.png"
                              alt="photo"
                              sx={{ width: 200, height: 200 }}
                            />
                            <CancelIcon
                              onClick={() => setMaterial(null)}
                              color="error"
                            />
                          </div>
                        </a>
                      </EmbedPDF>
                    ) : (
                      <div className="upload_image_preview2">
                        <CardMedia
                          component="img"
                          image={material}
                          alt="photo"
                          sx={{ width: 200, height: 200 }}
                        />
                        <CancelIcon
                          onClick={() => setMaterial(null)}
                          color="error"
                        />
                      </div>
                    )
                  ) : (
                    <Box className="upload_image_bnr">
                      <label htmlFor="icon-button-file-vdo">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file-vdo"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg,application/pdf",
                          }}
                          onChange={(e: any) =>
                            handleMaterialUpload(e, "material")
                          }
                        />
                        <Button component="span" className="upload_image_btn">
                          <Add />
                        </Button>
                      </label>
                    </Box>
                  )}
                  {error && !material && (
                    <h6 className="err_msg">Image is required.</h6>
                  )}
                </Grid>
                {/* Tutor Selection */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Tutor*</Typography>
                  <AutocompleteMUI
                    options={tutorData?.data || []}
                    getOptionLabel={(option: any) =>
                      `${option.userName} (${option.name})`
                    }
                    value={
                      tutorData?.data?.find(
                        (tutor: any) => tutor._id === selectedTutor
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (!_id) {
                        // Only allow changing if not editing existing class
                        setSelectedTutor(newValue?._id || "");
                        formik.setFieldValue("tutor", newValue?._id || "");
                        formik.setFieldValue("subject", "");
                        formik.setFieldValue("grade", "");
                        formik.setFieldValue("promocode", "");
                        formik.setFieldValue("language", "");
                        formik.setFieldValue("coTeahcer", "");
                        setSelectedSubject("");
                        setSelectedGrade([]);
                        setSelectedLanguage("");
                        setSelectedCoTeacher("");
                      }
                    }}
                    disabled={Boolean(_id)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search and select tutor"
                        className="text_field"
                        error={
                          formik.touched.tutor && Boolean(formik.errors.tutor)
                        }
                        helperText={formik.touched.tutor && formik.errors.tutor}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        <Box>
                          <Typography variant="body1">
                            {option.userName} ({option.name})
                          </Typography>
                          {/* <Typography variant="body2" color="textSecondary">
                            {option.email} - {option.phoneNo}
                          </Typography> */}
                        </Box>
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value._id
                    }
                  />
                  {formik.touched.tutor && formik.errors.tutor && (
                    <Typography color="error" variant="caption">
                      {formik.errors.tutor}
                    </Typography>
                  )}
                </Grid>
                {/* Subject Selection */}
                {/* {formik.values.tutor && ( */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Select Subject*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedSubject}
                      displayEmpty
                      disabled={!formik.values.tutor}
                      onChange={handleSubjectChange}
                      error={
                        formik.touched.subject && Boolean(formik.errors.subject)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Subject
                      </MenuItem>
                      {allSubject?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.subject && formik.errors.subject && (
                      <Typography color="error" variant="caption">
                        {formik.errors.subject}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {/* )} */}
                {/* Topic Input */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Topic*</Typography>
                  <TextField
                    className="text_field"
                    fullWidth
                    name="name"
                    placeholder="Enter Class Topic"
                    value={formik.values.name}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value?.length > 50) {
                        return;
                      }

                      if (isValidInput(value)) {
                        formik.setFieldValue("name", value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                {/* Grade Selection */}
                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Grade Options
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedGrade}
                      displayEmpty
                      onChange={handleGradeChange}
                      error={
                        formik.touched.grade && Boolean(formik.errors.grade)
                      }
                    >
                      <MenuItem value="not" disabled>
                        Select Grade
                      </MenuItem>
                      {classOptions?.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.grade && formik.errors.grade && (
                      <Typography color="error" variant="caption">
                        {formik.errors.grade}
                      </Typography>
                    )}
                  </FormControl>
                </Grid> */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Grade Levels & Ages*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      multiple
                      value={selectedGrade.map(String)}
                      displayEmpty
                      onChange={handleGradeChange}
                      error={
                        formik.touched.grade && Boolean(formik.errors.grade)
                      }
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return <em>Select Grade</em>;
                        }
                        return (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={
                                  classOptions.find(
                                    (opt) => opt.value === String(value)
                                  )?.label || value
                                }
                                onDelete={() => {
                                  // Remove the selected grade
                                  const newGrades = selectedGrade.filter(
                                    (grade) => String(grade) !== String(value)
                                  );
                                  setSelectedGrade(newGrades);
                                  formik.setFieldValue("grade", newGrades);
                                }}
                                deleteIcon={
                                  <CloseIcon style={{ fontSize: 16 }} />
                                }
                              />
                            ))}
                          </Box>
                        );
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Grade
                      </MenuItem>
                      {classOptions?.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          <Checkbox
                            checked={selectedGrade
                              .map(String)
                              .includes(String(item.value))}
                          />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.grade && formik.errors.grade && (
                      <Typography color="error" variant="caption">
                        {formik.errors.grade}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography className="custom_label">Grade Levels</Typography>
                  <GradeSelector
                    value={formik.values.grade}
                    onChange={(grades) => formik.setFieldValue("grade", grades)}
                    mode="category" // or "individual" based on your needs
                  />
                  {formik.touched.grade && formik.errors.grade && (
                    <Typography color="error" variant="caption">
                      {formik.errors.grade}
                    </Typography>
                  )}
                </Grid> */}
                {/* Promocode Input */}
                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Promocode</Typography>
                  <TextField
                    className="text_field"
                    fullWidth
                    name="promocode"
                    placeholder="Promocode"
                    value={formik.values.promocode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Grid> */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Promocode</Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      multiple
                      value={selectedPromoCodes}
                      displayEmpty
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedPromoCodes(
                          typeof value === "string" ? value.split(",") : value
                        );
                      }}
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return <em>Select Promocode</em>;
                        }
                        return (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={
                                  allPromoCode.find((p) => p._id === value)
                                    ?.name || value
                                }
                                onDelete={() => {
                                  // Remove the selected promo code
                                  const newPromoCodes =
                                    selectedPromoCodes.filter(
                                      (code) => code !== value
                                    );
                                  setSelectedPromoCodes(newPromoCodes);
                                }}
                                deleteIcon={
                                  <CloseIcon style={{ fontSize: 16 }} />
                                }
                              />
                            ))}
                          </Box>
                        );
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Promocode
                      </MenuItem>
                      {allPromoCode?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          <Checkbox
                            checked={selectedPromoCodes.indexOf(item._id) > -1}
                          />
                          <ListItemText primary={item.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Promocode</Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      multiple
                      value={selectedPromoCodes}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedPromoCodes(
                          typeof value === "string" ? value.split(",") : value
                        );
                      }}
                      renderValue={(selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={
                                allPromoCode.find((p) => p._id === value)
                                  ?.name || value
                              }
                            />
                          ))}
                        </Box>
                      )}
                    >
                      {allPromoCode?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          <Checkbox
                            checked={selectedPromoCodes.indexOf(item._id) > -1}
                          />
                          <ListItemText primary={item.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> */}
                {/* Seat Limits */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Seat Limits*</Typography>
                  <TextField
                    className="text_field"
                    fullWidth
                    type="text"
                    name="seat"
                    placeholder="Seat Limit"
                    inputProps={{ min: 1, max: 1000000 }}
                    value={formik.values.seat}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value[val.target.value.length - 1] === "."
                      ) {
                        return;
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.seat && Boolean(formik.errors.seat)}
                    helperText={formik.touched.seat && formik.errors.seat}
                  />
                </Grid>
                {/* Fee per Student */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Fee per Student*
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFreeLesson}
                        onChange={handleFreeLessonChange}
                        color="primary"
                      />
                    }
                    label={"Free Lesson"}
                  />
                  {!selectedFreeLesson && (
                    <TextField
                      className="text_field"
                      fullWidth
                      type="text"
                      name="fee"
                      placeholder="Fee per Student"
                      inputProps={{ min: 0, max: 10000 }}
                      value={formik.values.fee}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Only allow numbers
                        if (/^\d*$/.test(value)) {
                          const numericValue = parseInt(value || "0", 10);

                          // Limit to 10,000
                          if (numericValue <= 10000) {
                            formik.setFieldValue("fee", value);

                            //  Directly call the existing handler
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.fee && Boolean(formik.errors.fee)}
                      helperText={formik.touched.fee && formik.errors.fee}
                    />
                  )}
                </Grid>
                {/* Payment Type */}
                {!selectedFreeLesson && (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Payment Type *
                    </Typography>

                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="payment-type"
                        name="paymentType"
                        value={
                          formik.values.paymentType || CLASS_PAYMENT.SESSION
                        }
                        onChange={formik.handleChange}
                      >
                        <FormControlLabel
                          value={CLASS_PAYMENT.SESSION}
                          control={<Radio />}
                          label="Per Session"
                          sx={{ mr: 3 }}
                        />
                        <FormControlLabel
                          value={CLASS_PAYMENT.PER_HOUR}
                          control={<Radio />}
                          label="Per Hour"
                        />
                      </RadioGroup>

                      {formik.touched.paymentType &&
                        formik.errors.paymentType && (
                          <Typography color="error" variant="caption">
                            {formik.errors.paymentType}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                )}
                {/* Class Availability */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Allow for private class
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedAvailability}
                        onChange={handleAvailabilityChange}
                        color="primary"
                      />
                    }
                    label={"Allow"}
                  />
                </Grid>
                {/* Language of Instruction */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Language of Instruction*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedLanguage}
                      displayEmpty
                      onChange={handleLanguageChange}
                      error={
                        formik.touched.language &&
                        Boolean(formik.errors.language)
                      }
                    >
                      <MenuItem value="" disabled>
                        Language of Instruction*
                      </MenuItem>
                      <MenuItem value={TeachingLanguage.English}>
                        English
                      </MenuItem>
                      <MenuItem value={TeachingLanguage.Arabic}>
                        Arabic
                      </MenuItem>
                      <MenuItem value={TeachingLanguage.Both}>Both</MenuItem>
                    </Select>
                    {formik.touched.language && formik.errors.language && (
                      <Typography color="error" variant="caption">
                        {formik.errors.language}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {/* Type of Class Dropdown */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Type of Class*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={formik.values.classType2 || ""}
                      displayEmpty
                      onChange={formik.handleChange}
                      name="classType2"
                      error={
                        formik.touched.classType2 &&
                        Boolean(formik.errors.classType2)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Class Type
                      </MenuItem>
                      {Object.entries(CLASS_TYPE2).map(([key, value]) => {
                        // Filter out numeric keys from enum reverse mapping
                        if (isNaN(Number(key))) {
                          return (
                            <MenuItem key={value} value={value}>
                              {key.replace(/_/g, " ")}
                            </MenuItem>
                          );
                        }
                        return null;
                      })}
                    </Select>
                    {formik.touched.classType2 && formik.errors.classType2 && (
                      <Typography color="error" variant="caption">
                        {formik.errors.classType2}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {/* Class Setting */}
                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Class Setting*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedSetting}
                      displayEmpty
                      onChange={handleSetting}
                      error={
                        formik.touched.setting && Boolean(formik.errors.setting)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Setting
                      </MenuItem>
                      <MenuItem value={1}>Publish</MenuItem>
                      <MenuItem value={2}>Draft</MenuItem>
                    </Select>
                    {formik.touched.setting && formik.errors.setting && (
                      <Typography color="error" variant="caption">
                        {formik.errors.setting}
                      </Typography>
                    )}
                  </FormControl>
                </Grid> */}
                {/* Class Mode */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Location(Online/In-Person/Hybrid)*
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedClassType}
                      displayEmpty
                      onChange={handleClassTypeChange}
                      error={
                        formik.touched.classType &&
                        Boolean(formik.errors.classType)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select location type
                      </MenuItem>
                      <MenuItem value={ClassMode.Online}>Online</MenuItem>
                      <MenuItem value={ClassMode.Offline}>In-Person</MenuItem>
                      <MenuItem value={ClassMode.Hybrid}>Hybrid</MenuItem>
                    </Select>
                    {formik.touched.classType && formik.errors.classType && (
                      <Typography color="error" variant="caption">
                        {formik.errors.classType}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {(selectedClassType == "1" || selectedClassType == "3") && (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    {/* <Typography className="custom_label">Address</Typography>
                                <TextField
                                  className="text_field"
                                  hiddenLabel
                                  type={"text"}
                                  name="address"
                                  variant="outlined"
                                  fullWidth
                                  placeholder="Address"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address}
                                  helperText={
                                    formik.touched.address && formik.errors.address
                                      ? formik.errors.address.toString()
                                      : ""
                                  }
                                /> */}
                    <Typography className="custom_label ">Address</Typography>
                    <Autocomplete
                      onLoad={onLoad}
                      onPlaceChanged={() => onPlaceChanged()}
                    >
                      <TextField
                        className="text_field add_cross"
                        hiddenLabel
                        name="address"
                        value={formik.values?.address}
                        placeholder="Enter Address"
                        fullWidth
                        helperText={
                          formik.touched.address &&
                          typeof formik.errors.address === "string"
                            ? formik.errors.address
                            : undefined
                        }
                        onChange={(e) => {
                          if (
                            e.target.value.trim() === "" ||
                            e.target.value === "."
                          ) {
                            formik.setFieldValue("address", "");
                          } else {
                            formik.handleChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                        InputProps={{
                          endAdornment: formik.values.address ? (
                            <InputAdornment position="end">
                              <IconButton onClick={handleClear}>
                                <CloseIcon />
                              </IconButton>
                            </InputAdornment>
                          ) : null,
                        }}
                      />
                    </Autocomplete>
                  </Grid>
                )}
                {/* Co-Teacher */}
                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Co-Teacher Email
                  </Typography>
                  <TextField
                    fullWidth
                    name="coTeacherEmail"
                    placeholder="Enter Co-Teacher Email"
                    value={formik.values.coTeacherEmail}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.coTeacherEmail &&
                      Boolean(formik.errors.coTeacherEmail)
                    }
                    helperText={
                      formik.touched.coTeacherEmail &&
                      formik.errors.coTeacherEmail
                    }
                    disabled={!Boolean(formik.values.tutor)}
                  />
                </Grid> */}
                {/* Co-Teacher */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Co-Teacher</Typography>
                  <AutocompleteMUI
                    options={
                      tutorData?.data?.filter(
                        (tutor: any) => formik.values.tutor !== tutor._id
                      ) || []
                    }
                    getOptionLabel={(option: any) =>
                      `${option.userName} (${option.name})`
                    }
                    value={
                      tutorData?.data?.find(
                        (tutor: any) => tutor._id === selectedCoTeacher
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setSelectedCoTeacher(newValue?._id || "");
                      formik.setFieldValue("coTeahcer", newValue?._id || "");
                    }}
                    disabled={!Boolean(formik.values.tutor)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search and select co-teacher"
                        className="text_field"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        <Box>
                          <Typography variant="body1">
                            {option.userName} ({option.name})
                          </Typography>
                          {/* <Typography variant="body2" color="textSecondary">
                            {option.email}
                          </Typography> */}
                        </Box>
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value._id
                    }
                  />
                </Grid>
                {/* Timezone */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Timezone</Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      value={selectedTimezone}
                      displayEmpty
                      onChange={handleTimezoneChange}
                      error={
                        formik.touched.timezone &&
                        Boolean(formik.errors.timezone)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Timezone
                      </MenuItem>
                      {timezone?.map(
                        (item: { label: string; value: string }) => (
                          <MenuItem key={item?.value} value={item?.value}>
                            {item.label}
                          </MenuItem>
                        )
                      )}
                    </Select>
                    {formik.touched.timezone && formik.errors.timezone && (
                      <Typography color="error" variant="caption">
                        {formik.errors.timezone}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {/* Slot Time */}
                <Grid item xs={12}>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">Slot Time*</Typography>

                    {/* Slot Duration Dropdown */}
                    <Box mb={2}>
                      <Typography variant="body2" mb={1}>
                        Slot Duration
                      </Typography>
                      <Select
                        value={slotDuration}
                        onChange={(e) =>
                          setSlotDuration(e.target.value as number)
                        }
                        fullWidth
                        defaultValue={60}
                        className="select_div"
                      >
                        <MenuItem value={30}>30 minutes</MenuItem>
                        <MenuItem value={45}>45 minutes</MenuItem>
                        <MenuItem value={60}>60 minutes</MenuItem>
                        <MenuItem value={90}>90 minutes</MenuItem>
                        <MenuItem value={120}>120 minutes</MenuItem>
                      </Select>
                    </Box>

                    <Box display="flex" gap={1} alignItems="center">
                      <TextField
                        type="time"
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                        fullWidth
                        className="text_field"
                      />
                      <Button
                        variant="contained"
                        onClick={() => {
                          if (selectedTime) {
                            const [hours, minutes] = selectedTime
                              .split(":")
                              .map(Number);
                            const date = new Date();
                            date.setHours(hours, minutes + slotDuration, 0, 0);
                            const endTime = date.toTimeString().slice(0, 5);

                            if (doesOverlap(selectedTime, endTime)) {
                              errorToast(
                                "This time overlaps with an existing slot."
                              );
                              return;
                            }

                            setSlotTime((prev) => [
                              ...prev,
                              { start: selectedTime, end: endTime },
                            ]);
                            setSelectedTime("");
                          }
                        }}
                      >
                        Add
                      </Button>
                    </Box>

                    <Box mt={2}>
                      {slotTime.map((slot, index) => (
                        <Box
                          key={index}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt={1}
                          p={1}
                          sx={{ background: "#f5f5f5", borderRadius: 1 }}
                        >
                          <Typography>
                            {slot.start} - {slot.end}
                          </Typography>
                          <Button
                            color="error"
                            size="small"
                            onClick={() =>
                              setSlotTime((prev) =>
                                prev.filter((_, i) => i !== index)
                              )
                            }
                          >
                            Remove
                          </Button>
                        </Box>
                      ))}
                    </Box>
                    {formSubmitted && slotTime.length === 0 && (
                      <Typography color="error" variant="caption">
                        Please add at least one time slot
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <CustomSelector
                    slotDates={slotDates}
                    setSlotDates={setSlotDates}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    repeatEveryWeeks={repeatEveryWeeks}
                    setRepeatEveryWeeks={setRepeatEveryWeeks}
                    continueForWeeks={continueForWeeks}
                    setContinueForWeeks={setContinueForWeeks}
                  />
                </Grid>
                {/* Searchable Tags */}
                <Grid item xs={12}>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Searchable Tags
                    </Typography>

                    <Box display="flex" gap={1} alignItems="center" mt={1}>
                      <TextField
                        fullWidth
                        value={tagInput}
                        // onChange={(e) => setTagInput(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!isValidInput(value)) return;
                          setTagInput(e.target.value);
                        }}
                        placeholder="Enter tag"
                        className="text_field"
                      />
                      <Button variant="contained" onClick={addTag}>
                        Add
                      </Button>
                    </Box>

                    <Box mt={2}>
                      {tags.map((tag, index) => (
                        <Box
                          key={index}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt={1}
                          p={1}
                          sx={{ background: "#f5f5f5", borderRadius: 1 }}
                        >
                          {editingIndex === index ? (
                            <>
                              <TextField
                                value={editValue}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isValidInput(value)) return;
                                  setEditValue(e.target.value);
                                }}
                                fullWidth
                              />
                              <IconButton onClick={() => updateTag(index)}>
                                <Save />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <Typography>{tag}</Typography>
                              <Box>
                                <IconButton
                                  onClick={() => {
                                    setEditingIndex(index);
                                    setEditValue(tag);
                                  }}
                                >
                                  <Edit />
                                </IconButton>
                                <IconButton
                                  onClick={() => removeTag(index)}
                                  color="error"
                                >
                                  <Delete />
                                </IconButton>
                              </Box>
                            </>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
                {/* Description */}
                <Grid item xs={12}>
                  <Typography className="custom_label">Description*</Typography>
                  <TextField
                    className="text_field"
                    fullWidth
                    multiline
                    minRows={4}
                    name="description"
                    placeholder="Description"
                    value={formik.values.description}
                    // onChange={formik.handleChange}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isValidInput(value)) return;
                      formik.handleChange(e);
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />

                  {/* {_id ? (
                    formik.values.description && (
                      <EditText
                        content={formik.values.description}
                        setContent={(value) => {
                          if (value.length === 1 && value === " ") return; // Prevent leading space
                          formik.setFieldValue("description", value); // Update Formik
                        }}
                      />
                    )
                  ) : (
                    <EditText
                      content={formik.values.description}
                      setContent={(value) =>
                        formik.setFieldValue("description", value)
                      }
                    />
                  )} */}
                </Grid>
                {/*  Learnering Objective */}
                <Grid item xs={12}>
                  <Typography fontWeight={"700"} variant="body2" mb={2}>
                    Learnering Objective
                  </Typography>
                  <Typography className="custom_label">
                    What will students learn?.*
                  </Typography>
                  <TextField
                    className="text_field"
                    fullWidth
                    multiline
                    minRows={4}
                    name="learninig"
                    placeholder="What will students learn..."
                    value={formik.values.learninig}
                    // onChange={formik.handleChange}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isValidInput(value)) return;
                      formik.handleChange(e);
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.learninig &&
                      Boolean(formik.errors.learninig)
                    }
                    helperText={
                      formik.touched.learninig && formik.errors.learninig
                    }
                  />
                </Grid>
                {/* Learning Outcomes */}
                <Grid item xs={12}>
                  <Typography fontWeight={"700"} variant="body2" mb={2}>
                    Learning Outcomes
                  </Typography>

                  <Box mb={1}>
                    <Typography className="custom_label">
                      All learners will be able to...
                    </Typography>
                    <TextField
                      className="text_field"
                      fullWidth
                      multiline
                      minRows={4}
                      name="learninigOutcome1"
                      placeholder="All learners will be able to..."
                      value={formik.values.learninigOutcome1}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!isValidInput(value)) return;
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </Box>

                  <Box mb={1}>
                    <Typography className="custom_label">
                      Most learners will be able to...
                    </Typography>
                    <TextField
                      className="text_field"
                      fullWidth
                      multiline
                      minRows={4}
                      name="learninigOutcome2"
                      placeholder="Most learners will be able to..."
                      value={formik.values.learninigOutcome2}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!isValidInput(value)) return;
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </Box>

                  <Box mb={1}>
                    <Typography className="custom_label">
                      Some learners will be able to...
                    </Typography>
                    <TextField
                      className="text_field"
                      fullWidth
                      multiline
                      minRows={4}
                      name="learninigOutcome3"
                      placeholder="Some learners will be able to..."
                      value={formik.values.learninigOutcome3}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!isValidInput(value)) return;
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </Box>
                </Grid>
                {/* Custom Note */}
                <Grid item xs={12}>
                  <Typography className="custom_label">Custom Note</Typography>
                  {_id ? (
                    formik.values.customNote && (
                      <EditText
                        content={formik.values.customNote}
                        setContent={(value) => {
                          if (value.length === 1 && value === " ") return; // Prevent leading space
                          formik.setFieldValue("customNote", value); // Update Formik
                        }}
                      />
                    )
                  ) : (
                    <EditText
                      content={formik.values.customNote}
                      setContent={(value) =>
                        formik.setFieldValue("customNote", value)
                      }
                    />
                  )}
                  {/* <TextField
                    className="text_field"
                    fullWidth
                    multiline
                    minRows={4}
                    name="customNote"
                    placeholder="Custom Note"
                    value={formik.values.customNote}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  /> */}
                </Grid>
                {/* Submit Button */}
                <Grid item xs={12}>
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      Submit
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </form>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ProfileSetup;
